import * as React from 'react';
import { customerApplications } from '@applications/channel-care'
import { withRouter, IWithRouterProps } from '@utils/withRouterWrapper';
import { ListCasesFilterInt } from '../view-cases/components/cases-table/cases-table-filter-int';
import './style.less';
import { secureRouteBuilder } from '@applications/secure-route';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import { getChannelCareFlags } from '@telstra-connect/channel-care/feature-flags/load-flags';
import { ISubscriptionsClientState } from '@telstra-connect/channel-care/state/subscription-state';
import { IChannelCareAppState, ILoadCasesRequest, ISortColumn } from '@telstra-connect/channel-care/state';
import {connect, useDispatch} from 'react-redux';
import ViewCases from '../view-cases/index-lazy';
import * as qs from 'query-string';
import { IUserManagementClientState } from '@telstra-connect/channel-care/state/user-management-state';
import { Routes } from '@applications/channel-care';
import { updateSorting } from '@telstra-connect/channel-care/methods/common';
import { ICustomerProfileRequest, ICustomerProfileClientState } from '@telstra-connect/channel-care/state/token-state';
import { State as LoginState } from '@telstra-connect/login';
import { updateCompanyId } from '@telstra-connect/channel-care/methods/update-company-id';
import { NewCompanyDropdown } from './components/new-company-dropdown';
import global from '@applications/global';
import ViewCasesUplift from '../view-cases-uplift/index-lazy';
import {setSelectedCidnGlobally} from "@redux/actions";

interface IUnifiedTrackViewOwnProps {
}
interface IUnifiedTrackViewStateProps {
    user: LoginState.IUserState;
    companyId: string;
    cases: ILoadCasesRequest,
    selectedSort: ISortColumn,
    customerProfile?: ICustomerProfileRequest
}

interface IUnifiedTrackViewDispatchProps {
    updateSorting: (selectedColumn: ISortColumn) => void;
    updateCompanyId: (selectedCompanyId: string) => void;
    updateGlobalCidn: (selectedCompanyId: string) => void;

}
interface ICasesState {
    updatedCompanyId: string,
}

type ICCDUnifiedTrackViewProps = IUnifiedTrackViewOwnProps &
IUnifiedTrackViewStateProps &
IUnifiedTrackViewDispatchProps &
IWithRouterProps;

class UnifiedTrackViewComponent extends React.Component<ICCDUnifiedTrackViewProps, ICasesState> {
    constructor(props: ICCDUnifiedTrackViewProps) {
        super(props);
        this.state = {
            updatedCompanyId: this.props.companyId,
        }
    }

    public componentDidMount() {
        this.props.updateGlobalCidn(this.state.updatedCompanyId);
    }

    public shouldComponentUpdate(nextProps, nextState, nextContext) {
        const isInternational = this.isInternationalUser(this.getCidn(nextProps))
        const isCompanyUpdated = this.state.updatedCompanyId !== nextState.updatedCompanyId
        return isInternational || isCompanyUpdated;
    }

    public componentWillUnmount() {
        // Cleanup Company ID set in global state.
        this.props.updateGlobalCidn('');
    }

    public render() {
        const params = qs.parse(this.props.location.search);
        const hasBilling = customerApplications.filter((app) => app.applicationName === 'Billing').length !== 0;
        const isTrackingRoute = this.props.location.pathname.includes(Routes.OrderTrackerUnifiedTrackingEnquiries)
        const tryAgain = () => window.location.reload();
        const selectedFilter = {
            status: (isTrackingRoute && params.source === 'card') ? ['New', 'In progress', 'On hold'] : [],
            assignedTo: (isTrackingRoute && params.source === 'card') ? ['Telstra', 'Customer', 'N/A'] : [],
            dates: [],
            selectedDateInput: [],
            submittedBy: []

        }
        const isInternational = this.isInternationalUser(this.getCidn(this.props));
        const onClickBillingEnquiryUrl = () => this.props.navigate(secureRouteBuilder('/billing/summary/enquiry'));
        const showNewcompanyDropdown = global.applications['Channel Care'].showNewcompanyDropdown;
        const isIntlUser = showNewcompanyDropdown ? this.isInternationalUser(this.state.updatedCompanyId) : isInternational;
        return (
            <div className="tc-cc ui-channel-care-tracking-page">
                {!isIntlUser &&
                    hasBilling && <div className="channel-care-tracking-banner">
                    <div className="cc-banner-text-container">
                        <span><SvgIcon name="icon-system-info-small" className="custom-svg-icon-class" /></span>
                        <span className="cc-banner-text">
                                Track your support enquiries below. To track billing enquiries for newer services&nbsp;
                            <span className="tc-unified-nav-link"
                                onClick={onClickBillingEnquiryUrl}>go here.</span>
                        </span>
                    </div>
                </div>}
                <div className="cc-view-cases-page">
                    {
                        (
                            !getChannelCareFlags()?.tedig3349BanAndSearchAndListPageUplift ||
                            isIntlUser
                        ) &&
                        showNewcompanyDropdown &&
                        <NewCompanyDropdown updateCompanyid={this.updateCompanyid}
                            updatedCompanyId={this.state.updatedCompanyId}/>}
                    {
                        isIntlUser && getChannelCareFlags().CCDIntSupportUnifiedList ?
                            <ListCasesFilterInt
                                unifiedTrackView={true}
                                onTryAgain={tryAgain}
                                cidn={this.getCidn(this.props)}
                                updatedCompanyId={this.state.updatedCompanyId}
                            />
                            : getChannelCareFlags()?.tedig3349BanAndSearchAndListPageUplift ?
                                <ViewCasesUplift
                                    selectedFilter={selectedFilter}
                                    updatedCompanyId={this.state.updatedCompanyId}
                                    updateCompanyid={this.updateCompanyid}
                                />
                                : <ViewCases
                                    unifiedView={true}
                                    selectedFilter={selectedFilter}
                                    updatedCompanyId={this.state.updatedCompanyId}
                                    showNewcompanyDropdown
                                    updateCompanyid={this.updateCompanyid}
                                />
                    }
                </div>
            </div>
        );
    }
    public updateCompanyid = (selectedCompanyId) => {
        this.setState({updatedCompanyId: selectedCompanyId})
    }
    private isInternationalUser = (cidn: string): boolean => {

        if (cidn && cidn.length >= 5 && cidn.length <= 8) {
            return true
        }
        return false
    }

    private getCidn = (props): string => {
        const cidn = props.companyId || '0';
        return cidn;
    }

}

type SubscribedState =
    IChannelCareAppState &
    ISubscriptionsClientState &
    IUnifiedTrackViewOwnProps &
    IUserManagementClientState & ICustomerProfileClientState

const mapStateToProps = (
    state: SubscribedState
): IUnifiedTrackViewStateProps => {
    const { user } = state;
    return {
        user,
        cases: state.channelCare.cases,
        selectedSort: state.channelCare.selectedSort,
        customerProfile: state.tokens.customerProfile,
        companyId: (state.user.oauth.profile
            && state.user.oauth.profile.companyId
            && state.user.oauth.profile.companyId !== 'undefined') ?
            state.user.oauth.profile.companyId :
            state.userManagement &&
                state.userManagement.preferences && state.userManagement.preferences.data &&
                state.userManagement.preferences.data.lastSelectedCompanies &&
                state.userManagement.preferences.data.lastSelectedCompanies.length &&
                state.userManagement.preferences.data.lastSelectedCompanies[0].cidn ?
                state.userManagement.preferences.data.lastSelectedCompanies[0].cidn : ''
    };
};

const mapDispatchToProps = (dispatch): IUnifiedTrackViewDispatchProps => {
    return {
        updateSorting: (selectedColumn: ISortColumn) =>
            dispatch(updateSorting(selectedColumn)),
        updateCompanyId: (selectedCompanyId: string) => dispatch(updateCompanyId(selectedCompanyId)),
        updateGlobalCidn: (selectedCompanyId: string) => dispatch(setSelectedCidnGlobally(selectedCompanyId))
    };
};

const UnifiedTrackView = withRouter(
    connect<
    IUnifiedTrackViewStateProps,
    IUnifiedTrackViewDispatchProps,
    {},
    SubscribedState
    >(
        mapStateToProps,
        mapDispatchToProps
    )(UnifiedTrackViewComponent)
);

export default UnifiedTrackView;
